export default __webpack_public_path__ + "static/media/10.f35c17b0.jpg";